export default function deleteInvoiceReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'DELETE_INVOICE_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'DELETE_INVOICE_ERROR':
            return {...state, ...{ error: action.error }};

        case 'DELETE_INVOICE_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}